<template>
  <div :class="cssclass">
    <div v-if="!logged" class="justify-center q-mx-sm">
      <div class="row justify-center q-gutter-x-md">
        <div class="col" :to="{name:'User_SignUp'}">
          <q-btn flat color="primary" size="xl" :to="{name:'User_SignUp'}" icon="img:/assets/icons/create-account-dig.svg" />
          <p class="text-subtitle1"><a class="normal-link" :to="{name:'User_SignUp'}">Create an account</a></p>
        </div>
        <div class="col">
          <q-btn flat color="primary" size="xl" to="/how-it-works" icon="img:/assets/icons/how-it-works-dig.svg" />
          <p class="text-subtitle1"><a class="normal-link" to="/how-it-works"> How it works?</a></p>
        </div>
      </div>
      <p>Have an account?
        <router-link :to="{name: 'User_SignIn'}" class="text-primary">Sign In</router-link>
        now.
      </p>
      <!--<p>
        <router-link :to="{name:'User_SignUp'}">Create a free account</router-link>
        and use it anywhere, anytime.
      </p>
      <p>Have an account?
        <router-link :to="{name: 'User_SignIn'}">Sign In</router-link>
        to use
        your saved QrCode.
      </p>  -->
    </div>
    <!-- <div v-else>
      <p>Scan your code to earn perks.</p>
      <div class="row q-col-gutter-x-md q-col-gutter-y-md">
        <div class="col-12">
          <q-btn label="Logout" class="full-width" size="md" unelevated @click="handleLogout" color="primary"/>
        </div>
      </div>
    </div>-->
  </div>
  
</template>
<script>

import { ref } from '@vue/reactivity';
import { inject } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useQuasar } from 'quasar';

export default {
  name: 'SignInBar',
  props: ['logged', 'cssclass'],
  setup(){
    const axios = inject('axios')
    const store = useStore()
    const $q = useQuasar()
    
    function handleLogout() {
      axios.get(`${process.env.VUE_APP_URL}/logout`)
        .then(async resp => {    
          store.commit('setUser', null)
          store.commit('setClearHistory')
          store.commit('clearPlace')
          location.reload()
        })
        .catch(err => {
          $q.notify({
            message: 'An error has ocurred!',
            caption: err.message,
            color: 'negative'
          })
        })
    }
    
    return {handleLogout}
  }
}
</script>
<style scoped>
.qrcode img {
  cursor: pointer;
}
</style>